import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useTranslation } from "react-i18next";

const  EdTopReleasesTable = ({ topReleasesData }) => {
  const { t } = useTranslation();

  const tableOptions = {
    noDataText: t("general.table.noDataAvailable"),
  };

  return (
    <>
      <BootstrapTable
        hover
        condensed
        search={false}
        bordered={false}
        data={topReleasesData}
        deleteRow={false}
        insertRow={false}
        tableHeaderClass="mb-0"
        options={tableOptions}
      >
        <TableHeaderColumn width="100" dataField="release_name" isKey={true} dataSort={true}>
          {t("earningsDrilldown.view.top5Releases.table.column.releaseName")}
        </TableHeaderColumn>
        
        <TableHeaderColumn width="100" dataField="release_revenue" dataSort={true}>
          {t("earningsDrilldown.view.top5Releases.table.column.revenue")}
        </TableHeaderColumn>
      </BootstrapTable>
    </>
  );
};

export default EdTopReleasesTable;
